<div class="preview-error">
  <u-icon class="preview-error-icon" [model]="{ type: 'font', value: 'icon-exclamation-mark-circle' }"> </u-icon>
  <p class="preview-error-message">There was a problem loading {{ text }}.<br />please try again.</p>
  <u-button label="Try again" type="primary" [styles]="{ width: '90' }" (onClick)="tryAgain()"></u-button>
</div>
